<template>
  <div>
    <v-layout class="banner">
      <div class="banner-img"></div>
    </v-layout>
    <v-container class="intro">
      <v-row>
        <v-col cols="12">
          <div class="inner">
            <h5 class="title-sm">Riiqo Chat</h5>
            <h1>Live Chat! Because, Why Wouldn't We Have That?</h1>
            <router-link to="contact" class="btn">Get Started</router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>
    
    <div class="riiqosxn riiqosxn-bar">
      <h1 class="riiqosxn-title">Features</h1>
    </div>

    <div class="riiqosxn riiqosxn-features">
      <div class="riiqosxn-img"></div>
      <v-container>
        <!-- <h1 class="riiqosxn-title">Features</h1> -->
        <v-row class="row-features">
          <v-col cols="12" sm="6" xl="6"></v-col>
          <v-col cols="12" sm="6" xl="6" class="riiqosxn-content">
            <h1>Multiple Ways <br/>To Communicate</h1>
            <p>Automatically change your status online or offline on your website, so your customer can live chat with you, or fill out a contact form. Guide your leads or customers to correct channels to answer their questions quickly.</p>
            <v-row class="mod-cf">
              <v-col cols="12" sm="4" class="mod-cf__item">
                <span class="_online"></span>
                <h4 class="item-title">Live/Offline <br/>Chat</h4>
              </v-col>
              <v-col cols="12" sm="4" class="mod-cf__item">
                <span class="_users"></span>
                <h4 class="item-title">Assign <br/>Chats</h4>
              </v-col>
              <v-col cols="12" sm="4" class="mod-cf__item">
                <span class="_storage"></span>
                <h4 class="item-title">Turn Display <br/>Offline</h4>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-new">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="riiqosxn-content">
            <h1>Don’t Wait – Create Customers</h1>
            <p>You can turn any chat contact into an actual CRM entry immediately. Select the category they fit in, fill out the necessary information, and BAM! A new customer card is created and ready to manage.</p>
          </v-col>
          <v-col cols="12" sm="6" class="col-left">
            <div class="riiqosxn-img"></div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-forward">
      <v-container>
        <v-row>
          <v-col cols="12" md="8" offset-md="2" class="riiqosxn-content">
            <h1>Claim &amp; Forward Messages</h1>
            <p>Your users can claim messages as they appear to ensure there isn’t any confusion. Didn’t mean to claim it? Easily forward that message to the correct user or department.</p>
          </v-col>
        </v-row>
        <div class="mod-fm">
          <div class="row mod-row">
            <div class="mod-row__item item-1"></div>
            <div class="mod-row__item item-2"></div>
            <div class="mod-row__item item-3"></div>
          </div>
        </div>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-texting">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="riiqosxn-content">
            <h1>Texting For Better Interactions</h1>
            <p>Texts are read more often, and are the main mode of communication for most people. Choose a number, and whether you place it on the web or on a billboard, you can track it, and have conversations with the rest of you communications.</p>
          </v-col>
          <v-col cols="12" sm="6" class="col-left">
            <div class="riiqosxn-img"></div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-slackint">
      <v-container>
        <v-row>
          <v-col cols="12" md="8" offset-md="2" class="riiqosxn-content">
            <span class="_slack slack-icon"></span>
            <h1>Slack Integration</h1>
            <p>If you are a Slack lover, you can keep using it within the Riiqo system, with access to all your channels, so you won’t miss a beat.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-userchat">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6">
            <div class="riiqosxn-img"></div>
          </v-col>
          <v-col cols="12" sm="6" class="riiqosxn-content">
            <h1>User to User Chat</h1>
            <p>Not a Slack user? We have you covered. Chat with as many users or groups in your company as needed right from our Chat window.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    
    <SxnCta />
  </div>
</template>

<script>
import { bus } from '../../../main'
import SxnCta from '../../commons/SxnCta'
export default {
  name: 'chat',
  components: { SxnCta },
  data: () => ({
    
  }),
  mounted() {
		console.log(this.$route);
		bus.$emit('update-route', this.$route);
  }
};
</script>
